import { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'
import { useSites } from 'store'

import { convertDateRange } from '../../hooks/use-traffic'
import { useGetStatsTimeRange } from '../../store'

const OPERATION_TRAFFIC = gql`
  query TrafficDistributionGroupByNetworkAndSsid($sfIds: [ID], $startsAt: String, $endsAt: String) {
    stats: trafficDistributionGroupByNetworkAndSsid(sf_ids: $sfIds, starts_at: $startsAt, ends_at: $endsAt) {
      network_name
      ssid_name
      download
      upload
    }
  }
`

const useData = () => {
  const [globalRange] = useGetStatsTimeRange()
  const [{ selected }] = useSites()

  const {data, loading} = useQuery(OPERATION_TRAFFIC, {
    variables: {
      sfIds: selected.map(({sf_id}) => sf_id),
      ...convertDateRange(globalRange)
    }
  })

  const formattedData = useMemo(() => {
    if (!data) {
      return []
    }
    return data.stats
      .filter(({download, upload}) => parseInt(download) + parseInt(upload) > 0)
      .map(values => ({...values, download: parseInt(values.download) / 1000, upload: parseInt(values.upload) / 1000}))
  }, [data])

  const total = useMemo(() => {
    return formattedData.reduce((total, {download, upload}) => total + download + upload,0)
  }, [data])

  const ssidsByTypes = useMemo(() => {
    return ['guest', 'private', 'other'].map(type => {
      const ssids = formattedData.filter(({network_name}) => network_name === type)
      const totalType = ssids.reduce((total, {download, upload}) => total + download + upload,0)
      return {
        type,
        total: totalType,
        percentage: ((totalType * 100) / total).toFixed(1),
        ssids: ssids.map(ssid => {
          const percentage = (((ssid.download + ssid.upload) * 100) / total).toFixed(1)
          return {
            name: ssid.ssid_name,
            percentage,
            total: ssid.download + ssid.upload
          }
        })
      }
    })
  }, [formattedData])

  return {
    loading,
    data: ssidsByTypes
  }
}


export default useData